const roles = {
  LOCAL_ADMIN: 'LOCAL_ADMIN',
  PAYE_ADMIN: 'PAYE_ADMIN',
};

export default roles;
